import {UserId} from '@legit.health/ui';
import {DomainEvent} from '@/shared/contexts/EventDispatcherContext';

export const PATIENT_DELETED_EVENT = 'patient.deleted';

export interface PatientDeletedEvent extends DomainEvent {
  patientId: UserId;
}

export function createPatientDeletedEvent(patientId: UserId): PatientDeletedEvent {
  return Object.freeze({
    name: PATIENT_DELETED_EVENT,
    patientId
  });
}
